import "Data/ServerSource";
/** @namespace GIS.Data */
NS("GIS.Data");

/**
 * GIS.Data.LayerFeatures source
 * @class
 * @extends Data.ServerSource
 */
GIS.Data.LayerFeatures = Class(Data.ServerSource, /** @lends GIS.Data.LayerFeatures.prototype */ {
    url: "GIS/Web/LayerFeatures/",

    fields: [
        { name: "id", title: "id" }, // string
        { name: "layerid", title: "layerid" }, // string
        { name: "regionid", title: "regionid" }, // int
        { name: "districtid", title: "districtid" }, // int
        { name: "name", title: "name" }, // json
        { name: "geog", title: "geog" }, // json
        { name: "geogcenter", title: "geogcenter" }, // string
        { name: "addresscode", title: "addresscode" }, // string
        { name: "addresstext", title: "addresstext" }, // string
    ],
    /**
     * @param options
     * @param callback
     * @returns {Promise}
     */
    cluster: function(options, callback) {
        return this.call("cluster", options, callback);
    }
});
